'use client';

import { createContext, useContext } from 'react';
import type { CalendarContextValue, BookingContextValue } from './calendar.types';

export const CalendarContext = createContext<CalendarContextValue | null>(null);

export function useCalendarContext(): CalendarContextValue {
  const ctx = useContext(CalendarContext);
  if (!ctx)
    throw new Error(
      'Calendar compound components must be used within <Calendar.Root>'
    );
  return ctx;
}

export const BookingContext = createContext<BookingContextValue | null>(null);

export function useBookingContext(): BookingContextValue | null {
  return useContext(BookingContext);
}
